import React from 'react'
import SplitText from "../../../common/SplitText";
import { IoStar } from "react-icons/io5";

export default function Testimonial() {
    return (
        <div className='bg-gradient-to-br from-[#EFD7EF] via-[#F5F9FC] to-[#EAF8F9] px-[16px] sm:px-[24px] lg:px-[40px] py-[50px] sm:py-[70px] lg:py-[90px] xl:py-[120px] mt-[80px] sm:mt-[100px] relative'>
            <div className='flex justify-center'>
                <SplitText
                    text="Customer Testimonials"
                    tag="h2"
                    className='text-[#0F0200] text-[28px] sm:text-[38px] lg:text-[48px] xl:text-[54px] font-bold text-center'
                    delay={30}
                    duration={0.6}
                    ease="power3.out"
                    splitType="words, chars"
                    from={{ opacity: 0, y: 30 }}
                    to={{ opacity: 1, y: 0 }}
                    threshold={0.1}
                    rootMargin="-40px"
                    textAlign="center"
                />
            </div>
            <h5 className='text-[#475569] text-[15px] sm:text-[17px] lg:text-[19px] font-normal text-center mt-[10px] sm:mt-[14px] max-w-[620px] mx-auto'>Real stories and experiences from our thriving franchise partners</h5>
            
            <div className='w-11/12 max-w-[1360px] mx-auto grid md:grid-cols-2 xl:grid-cols-3 gap-[20px] lg:gap-[24px] mt-[36px] lg:mt-[48px]'>
                
                <div className='bg-white rounded-[24px] p-[28px] sm:p-[32px] border border-teal-100 shadow-card hover:shadow-card-hover hover:-translate-y-1.5 transition-all duration-300 flex flex-col justify-between text-left'>
                    <div className='flex gap-[4px] mb-[16px]'>
                        <IoStar fill='#FFC045' size={18}/>
                        <IoStar fill='#FFC045' size={18}/>
                        <IoStar fill='#FFC045' size={18}/>
                        <IoStar fill='#FFC045' size={18}/>
                        <IoStar fill='#FFC045' size={18}/>
                    </div>
                    <p className='text-[#475569] text-[15px] sm:text-[16px] font-normal leading-relaxed italic'>
                        “Like any middle-class family in Chennai, we wanted a genuine secondary income to support our children’s higher education without taking heavy loans. With ₹3 Lakhs of savings, we started the Rainbow Trucks Economy Cart near Tambaram. The kulfi is 100% pure milk, so neighborhood families and college students became loyal daily customers. It now gives us a steady monthly profit that easily takes care of our household commitments.”
                    </p>
                    <div className='mt-[24px] pt-[18px] border-t border-gray-100'>
                        <h4 className='text-[#181F38] text-[16px] sm:text-[17px] font-bold'>Murugan & Lakshmi (Tambaram, Chennai)</h4>
                        <p className='text-[#73C8BD] text-[13px] font-semibold mt-0.5'>Middle-Class Family Franchise Partners</p>
                    </div>
                </div>

                <div className='bg-white rounded-[24px] p-[28px] sm:p-[32px] border border-teal-100 shadow-card hover:shadow-card-hover hover:-translate-y-1.5 transition-all duration-300 flex flex-col justify-between text-left'>
                    <div className='flex gap-[4px] mb-[16px]'>
                        <IoStar fill='#FFC045' size={18}/>
                        <IoStar fill='#FFC045' size={18}/>
                        <IoStar fill='#FFC045' size={18}/>
                        <IoStar fill='#FFC045' size={18}/>
                        <IoStar fill='#FFC045' size={18}/>
                    </div>
                    <p className='text-[#475569] text-[15px] sm:text-[16px] font-normal leading-relaxed italic'>
                        “We had zero prior business experience and were worried about risking our hard-earned savings. But Rainbow Trucks gave us complete handholding—from cart setup near Anna Nagar to daily operating guidance. Because there is 0% royalty, every single rupee of profit remains with our family. In just 9 months, we recovered our initial capital and gained true financial security.”
                    </p>
                    <div className='mt-[24px] pt-[18px] border-t border-gray-100'>
                        <h4 className='text-[#181F38] text-[16px] sm:text-[17px] font-bold'>Kavitha & Ramesh (Trichy)</h4>
                        <p className='text-[#73C8BD] text-[13px] font-semibold mt-0.5'>First-Time Entrepreneurs & Franchisees</p>
                    </div>
                </div>

                <div className='bg-white rounded-[24px] p-[28px] sm:p-[32px] border border-teal-100 shadow-card hover:shadow-card-hover hover:-translate-y-1.5 transition-all duration-300 flex flex-col justify-between text-left md:col-span-2 xl:col-span-1 md:w-[70%] md:mx-auto xl:w-full'>
                    <div className='flex gap-[4px] mb-[16px]'>
                        <IoStar fill='#FFC045' size={18}/>
                        <IoStar fill='#FFC045' size={18}/>
                        <IoStar fill='#FFC045' size={18}/>
                        <IoStar fill='#FFC045' size={18}/>
                        <IoStar fill='#FFC045' size={18}/>
                    </div>
                    <p className='text-[#475569] text-[15px] sm:text-[16px] font-normal leading-relaxed italic'>
                        “Finding a low-investment business with genuine dignity and good daily profit was difficult for our middle-class family until we partnered with Rainbow Trucks. We started near Thillai Nagar with one cart. The hygienic cart design and natural taste attracted huge evening crowds. Today, we manage two carts, giving our entire household strong financial stability and peace of mind.”
                    </p>
                    <div className='mt-[24px] pt-[18px] border-t border-gray-100'>
                        <h4 className='text-[#181F38] text-[16px] sm:text-[17px] font-bold'>Suresh & Revathi (Trichy)</h4>
                        <p className='text-[#73C8BD] text-[13px] font-semibold mt-0.5'>2-Cart Family Business Owners</p>
                    </div>
                </div>

            </div>
        </div>
    )
}
